import type { ReactNode } from 'react';

export const symbol_align_justify_space_between: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M828.5-88.63Q820-97.25 820-110v-180h-70q-12.75 0-21.37-8.63Q720-307.25 720-320v-320q0-12.75 8.63-21.38Q737.25-670 750-670h70v-180q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v740q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM109.82-80Q97-80 88.5-88.63 80-97.25 80-110v-740q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v180h70q12.75 0 21.38 8.62Q240-652.75 240-640v320q0 12.75-8.62 21.37Q222.75-290 210-290h-70v180q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63Z"
		/>
	</svg>
);
